import get from 'lodash/get';
import { transformSearchEdges, FlattenedSearchResult } from './transformSearchEdges';

// This class handles search response processing and pagination for the Search component.
// It transforms GraphQL responses into flattened objects and manages pagination state.

class SearchResponseHandler {
  /**
   * Processes a GraphQL search response and returns flattened search results so we don't have to drill into node properties
   */
  static processSearchResponse(payload: any): FlattenedSearchResult[] {
    const edges = get(payload, 'data.sitterSearch.edges');
    return transformSearchEdges(edges);
  }

  /**
   * Handles pagination by updating the sitters array
   */
  private static handlePaginationUpdate(component: any, payload: any, append: boolean = false): void {
    const newSitters = this.processSearchResponse(payload);
    component.sitters = append ? component.sitters.concat(newSitters) : newSitters;
  }

  /**
   * Updates component metadata after processing search results
   */
  private static updateComponentMetadata(component: any, payload: any): void {
    component.searchResults = get(payload, 'data.sitterSearch');

    if (component.searchResultReceived) {
      component.searchResultReceived(payload);
    }

    component.loading = false;
  }

  /**
   * Main method to update search results with pagination support
   */
  static updateSearchResults(component: any, payload: any, isPagination = false): void {
    try {
      this.handlePaginationUpdate(component, payload, isPagination);
      this.updateComponentMetadata(component, payload);
    } catch (error) {
      console.error('Error processing search response:', error);
      if (component.onError) {
        component.onError(error);
      }
    }
  }
}

export default SearchResponseHandler;
